import { Checkbox, withStyles } from "@material-ui/core";
import React from "react";

interface ITaxCheckbox {
    checked: boolean;
}

const CheckboxWithYellowTick = withStyles({
    root: {
        '&$checked': {
            color: "#FFDD02",
        },
    },
    checked: {},
})(Checkbox);

export function TaxCheckBox({
    checked,
}: ITaxCheckbox) {
    return <CheckboxWithYellowTick
        checked={checked}
        disabled={true}
    />;
}
